import React, { Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { Select, DatePicker, ConfigProvider, notification, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import moment from "moment";

const { Option, OptGroup } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const downloadFile = (data, filename) => {
  var blob = new Blob([data], { type: "application/octet-stream" });
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobUrl =
      window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(blob)
        : window.webkitURL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobUrl;
    tempLink.setAttribute("download", filename);

    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    setTimeout(function () {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobUrl);
    }, 200);
  }
};

class JobDailyReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      areaId: null,
      jobStatus: null,
      mainProcessID: null,
      subProcessID: null,
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      startDateFilter: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      loading: "none"
    };
  }

  setArea = (value) => {
    this.setState({ areaId: value });
  };

  setJobStatus = (value) => {
    const processId = value.split(",");
    this.setState({
      jobStatus: value,
      mainProcessID: processId[0],
      subProcessID: processId[1],
    });
  };

  setStartDate = (value) => {
    this.setState({ startDate: value, startDateFilter: value });
  };

  setEndDate = (value) => {
    this.setState({ endDate: value });
  };

  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };

  genOption = () => {
    const wfProcesslist = this.props.jobStatus;
    if (wfProcesslist.length > 0) {
      const Optionheaderraw = wfProcesslist.filter(
        (data) =>
          JSON.parse(data.data_dynamic).configuration.dropdown_status
            .option_type === "group"
      );
      const Optionraw = wfProcesslist.filter(
        (data) =>
          JSON.parse(data.data_dynamic).configuration.dropdown_status
            .option_type === "label"
      );
      Optionheaderraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).configuration.dropdown_status.option_seq -
          JSON.parse(b.data_dynamic).configuration.dropdown_status.option_seq
        );
      });
      Optionraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).configuration.dropdown_status.option_seq -
          JSON.parse(b.data_dynamic).configuration.dropdown_status.option_seq
        );
      });
      return (
        <>
          {Optionheaderraw && Optionheaderraw.length > 0
            ? Optionheaderraw?.map((data, index) => (
                <OptGroup
                  label={data.process_desc}
                  key={`Option_progress_index_${index}`}
                >
                  {Optionraw && Optionraw.length > 0
                    ? Optionraw?.map((datas, indexs) => {
                        if (
                          JSON.parse(data.data_dynamic).configuration
                            .dropdown_status.option_group_id ===
                          JSON.parse(datas.data_dynamic).configuration
                            .dropdown_status.option_group_id
                        ) {
                          return (
                            <Option
                              name="jobStatus"
                              key={`job_status_${indexs + 1}`}
                              value={`${datas.mainProcessID},${datas.subProcessID}`}
                            >
                              <span className="default-thai-font">
                                {datas.process_desc}
                              </span>
                            </Option>
                          );
                        }
                        return null;
                      })
                    : null}
                </OptGroup>
              ))
            : Optionraw && Optionraw.length > 0
            ? Optionraw?.map((datass, indexss) => (
                <option
                  name="jobStatus"
                  key={`job_status_${indexss + 1}`}
                  value={`${datass.mainProcessID},${datass.subProcessID}`}
                >
                  <span className="default-thai-font">
                    {datass.process_desc}
                  </span>
                </option>
              ))
            : null}
        </>
      );
    }
  };

  clearSelect = () => {
    this.setState({
      areaId: null,
      jobStatus: null,
      mainProcessID: null,
      subProcessID: null,
    });
  };

  downloadReport = () => {    
    const token = Cookies.get("OperationToken");
    const url =
      process.env.REACT_APP_URL_API ||
      "https://planb.maxitask.com/maxioperationapi/api/";
    const axiosClient = axios.create({
      baseURL: url,
      headers: {
        "Content-type": "application/json",
        TokenUser: token,
      },
      responseType: "blob",
    });
    this.setState({loading: "block"})
    axiosClient
      .post("get_job_list_report", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        start_date: this.state.startDate + " 00:00:00",
        end_date: this.state.endDate + " 00:00:00",
        job_status: this.state.jobStatus,
        main_process_id: this.state.mainProcessID,
        sub_process_id: this.state.subProcessID,
        area_code: this.state.areaId,
      })
      .then((res) => {
        const filename =
          "job_daily_report-" + moment().format("YYYYMMDD_HHmmss") + ".xls";
        var blob = new Blob([res.data], { type: "application/octet-stream" });
        console.log("data", blob);
        console.log("size", blob.size);
        if (blob.size === 4096) {
          this.notify("info", "Informaton", "No Data");
        } else {
          downloadFile(res.data, filename);
          console.log('file download : '+filename)
        }
        this.setState({loading: "none"})
      })
      .catch((e) => {
        console.log("error generating report", e);
      });
  };

  render() {
    const locale = Cookies.get("locale");
    return (
      <div>
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["areaName"]
              : "Area name"}{" "}
            :
          </label>
          <div className="col-12 col-sm-6 col-form-input">
            <Select
              className="w-100"
              showSearch
              placeholder="Select area"
              value={this.state.areaId}
              onSelect={this.setArea}
            >
              <Option value="%" key={"all_area"}>
                <span className="default-thai-font">All Area</span>
              </Option>
              {this.props.areaCode.map((item, index) => (
                <Option value={item.area_code} key={index}>
                  <span className="default-thai-font">{item.area_code}</span>
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["job_status"]
              : "Job Status"}{" "}
            :
          </label>
          <div className="col-12 col-sm-6 col-form-input">
            <Select
              className="w-100"
              showSearch
              placeholder="Select job status"
              value={this.state.jobStatus}
              onSelect={this.setJobStatus}
            >
              {this.genOption()}
            </Select>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["startDate"]
              : "-"}{" "}
            :
          </label>
          <div className="col-12 col-sm-3 col-form-input">
            <ConfigProvider locale={locale}>
              <DatePicker
                format={"YYYY-MM-DD"}
                style={{ width: 120 }}
                placeholder={this.state.startDate}
                onChange={(date, dateString) => this.setStartDate(dateString)}
                defaultValue={moment(this.state.startDate, "YYYY-MM-DD")}
              />
            </ConfigProvider>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["enddate"]
              : "-"}{" "}
            :
          </label>
          <div className="col-12 col-sm-3 col-form-input">
            <ConfigProvider locale={locale}>
              <DatePicker
                format={"YYYY-MM-DD"}
                style={{ width: 120 }}
                placeholder={this.state.endDate}
                onChange={(date, dateString) => this.setEndDate(dateString)}
                defaultValue={moment(this.state.endDate, "YYYY-MM-DD")}
                disabledDate={d => !d || d.isSameOrBefore(moment(this.state.startDate).add(-1,"day"))}
              />
            </ConfigProvider>
          </div>
        </div>
        <div className="form-group row">          
          <div className="col-12 col-form-input text-center mt-3">
            <button
              className="btn btn-xs"
              onClick={this.clearSelect}
              style={{
                backgroundColor: "#e8ecef",
                marginRight: 30,
                width: 120,
              }}
            >
              <span>Clear</span>
            </button>
            <button
              className="btn btn-xs btn-primary"
              onClick={this.downloadReport}
            >
              <span>Confirm</span>
            </button>
          </div>
        </div>
        <div style={{position:"absolute",top:"10%",alignContent:"center",marginLeft:"-10%",width:"100%"}}><Spin style={{display: this.state.loading}} indicator={antIcon} /></div>
      </div>
    );
  }
}

export default JobDailyReport;
